import * as React from 'react';
import { Spinner } from '../../../../../Shared/index';
import { RouteComponentProps } from 'react-router-dom';
import _ from 'underscore';

import UnitTemplateAuthenticationButtons from './unit_template_authentication_buttons';
import UnitTemplateProfileActivityTable from './unit_template_profile_activity_table';
import UnitTemplateProfileDescription from './unit_template_profile_description';
import UnitTemplateProfileShareButtons from './unit_template_profile_share_buttons';
import UnitTemplateProfileStandards from './unit_template_profile_standards';

import { Activity } from '../../../../../../interfaces/activity';
import { UnitTemplateProfileInterface } from '../../../../../../interfaces/unitTemplate';
import { requestGet } from '../../../../../../modules/request/index';
import {
  getPageTitle,
  redirectToActivity,
  ACTIVITY_IDS_ARRAY,
  CLICKED_ACTIVITY_PACK_ID,
  COLLEGE_BOARD_SLUG,
  UNIT_NAME,
  UNIT_TEMPLATE_ID,
  UNIT_TEMPLATE_NAME
} from '../../../../../Shared';
import ScrollToTop from '../../../shared/scroll_to_top';
import AssignmentFlowNavigation from '../../assignment_flow_navigation';
import EvidenceGuardedButton from '../../../shared/evidenceGuardedButton';
import parsedQueryParams from '../../parsedQueryParams';

interface UnitTemplateProfileState {
  data: UnitTemplateProfile,
  loading: boolean,
  referralCode: string
}

export class UnitTemplateProfile extends React.Component<RouteComponentProps, UnitTemplateProfileState> {
  constructor(props) {
    super(props)
    this.state = {
      data: null,
      loading: true,
      referralCode: ''
    }
    document.title = getPageTitle('Assign', 'Featured Activity Pack')
  }

  componentDidMount() {
    const { match } = this.props;
    const { activityPackId } = match.params;
    this.getProfileInfo(activityPackId);
    window.sessionStorage.setItem(CLICKED_ACTIVITY_PACK_ID, activityPackId);
  }

  componentDidUpdate(prevProps: RouteComponentProps) {
    const { location, match } = this.props;
    const { activityPackId } = match.params as any;
    if (!_.isEqual(prevProps.location, location)) {
      this.setState({ loading: true, });
      this.getProfileInfo(activityPackId);
    }
  }

  getProfileInfo = (id: string) => {
    requestGet(`/teachers/unit_templates/profile_info?id=${id}`, (response: { data: UnitTemplateProfileInterface, referral_code: string }) => {
      this.displayUnit(response)
    })
  }

  displayUnit = (response: { data: UnitTemplateProfileInterface, referral_code: string }) => {
    const { data, referral_code } = response;
    this.setState({
      data,
      referralCode: referral_code,
      loading: false
    })
  }

  indexLink = () => {
    const { data } = this.state;
    const { non_authenticated } = data;
    return non_authenticated
      ? '/activities/packs'
      : '/assign/featured-activity-packs';
  }

  socialShareUrl = (referralCode: string) => {
    return `${window.location}${referralCode ? '?referral_code=' + referralCode : ''}`
  }

  socialText = (name: string, referralCode: string) => {
    return `Check out the '${name}' activity pack I just assigned on Quill.org! ${this.socialShareUrl(referralCode)}`
  }

  handleGoToEditStudents = () => {
    const { history } = this.props;
    const { data } = this.state;
    const { name, id, activities, } = data
    const activityIdsArray = activities.map((act: Activity) => act.id).toString()
    window.localStorage.setItem(UNIT_TEMPLATE_NAME, name)
    window.localStorage.setItem(UNIT_NAME, name)
    window.localStorage.setItem(ACTIVITY_IDS_ARRAY, activityIdsArray)
    window.localStorage.setItem(UNIT_TEMPLATE_ID, id)
    let link = `/assign/select-classes?unit_template_id=${id}`
    const collegeBoardActivityTypeSlug = parsedQueryParams()[COLLEGE_BOARD_SLUG]
    if (collegeBoardActivityTypeSlug) {
      link += `&${COLLEGE_BOARD_SLUG}=${collegeBoardActivityTypeSlug}`
    }

    history.push(link)
  }

  handleActivityClick = (e) => {
    const { target } = e
    const { id } = target
    redirectToActivity(id)
  }

  renderAssignButton = () => {
    const { data } = this.state;
    return (
      <EvidenceGuardedButton
        activities={data.activities || []}
        className="quill-button contained medium green focus-on-light"
        onClick={this.handleGoToEditStudents}
      >
        Select pack
      </EvidenceGuardedButton>
    )
  }

  renderMobileActivitiesList = ({ activities }) => {
    if(!activities) { return }

    return(
      <section className="mobile-activities-list-section">
        <ul>
          {activities.map(activity => {
            const { id, name } = activity
            return <li key={id}><a className="interactive-wrapper" id={id} onClick={this.handleActivityClick}>{name}</a></li>
          })}
        </ul>
      </section>
    )
  }

  render() {
    const { data, loading, referralCode } = this.state

    if (loading) {
      return <Spinner />
    } else {
      let navigation: any;
      const { name, id, non_authenticated, flag } = data
      const showSocials = flag === 'production';
      if (!non_authenticated) {
        navigation = (<AssignmentFlowNavigation
          button={this.renderAssignButton()}
          unitTemplateId={id}
          unitTemplateName={name}
        />)
      }
      return (
        <div className="unit-template-profile">
          <ScrollToTop />
          {navigation}
          <main className="unit-template-profile-container">
            <h1>
              <span>Activity Pack</span>
              {name}
            </h1>
            <UnitTemplateProfileActivityTable data={data} />
            <div className="first-content-section flex-row space-between first-content-section">
              <div className="description">
                {this.renderMobileActivitiesList(data)}
                <UnitTemplateProfileDescription data={data} />
              </div>
              <div className="assign-buttons-and-standards">
                <UnitTemplateProfileStandards data={data} />
                {non_authenticated && <UnitTemplateAuthenticationButtons name={name} />}
                {showSocials && <UnitTemplateProfileShareButtons data={data} text={this.socialText(name, referralCode)} url={this.socialShareUrl(referralCode)} />}
              </div>
            </div>
          </main>
        </div>
      )
    }
  }
}

export default UnitTemplateProfile
